module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0085.cda975a8.jpg";